"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TextareaAutosize.default;
  }
});

var _TextareaAutosize = _interopRequireDefault(require("./TextareaAutosize"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/TextareaAutosize/index.js
// module id = 201
// module chunks = 0